import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import {getCourseLabel} from '../../../../../utils/entity/course';

export const getData = (
  event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, program} = contexts;

  const courseLabel = getCourseLabel(course);

  return {
    avatar: program?.avatar,
    avatarPlaceholder: program?.title,
    title:
      /**
       * @i18n_parser
       *
       * t('notifications:course_paused.title')
       * t('notifications:course_resumed.title')
       */
      i18n.t(`notifications:${event.type}.title`, {
        courseDates: courseLabel ? `(${courseLabel})` : '',
        courseTitle: program?.title,
      }),
  };
};
